// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import AuthRedirect from './components/AuthRedirect';
import { AdminRoute, UserRoute } from './components/ProtectedRoute';

import WelcomeScreen from './screens/WelcomeScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import ResetPassword from './screens/ResetPassword';
import UserHomeScreen from './screens/UserHomeScreen';
import PagoPendienteScreen from './screens/PagoPendienteScreen';

import AdminDashboard from './screens/AdminDashboard';
import UsuariosAdmin from './components/admin/UsuariosAdmin';
import UsuarioDetalle from './components/admin/UsuarioDetalle';
import ListadoCategorias from './components/admin/ListadoCategorias';
import VideosPorCategoriaAdmin from './components/admin/VideosPorCategoriaAdmin';
import ReportesAdmin from './screens/ReportesAdmin';
import FaqAdminScreen from './screens/FaqAdminScreen';
import PlansScreen from './screens/PlansScreen';

function App() {
  return (
    <Router>
      <Routes>

        {/* REDIRECCIÓN SEGÚN LOGIN */}
        <Route path="/redirect" element={<AuthRedirect />} />

        {/* RUTAS PÚBLICAS Y DE PLANES */}
        <Route path="/" element={<WelcomeScreen />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/register" element={<RegisterScreen />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/plans" element={<PlansScreen />} />
        
        {/* PANTALLAS DE PAGO / TRANSFERENCIA */}
        <Route path="/pago-pendiente" element={<PagoPendienteScreen />} />
        <Route path="/pago-transferencia" element={<PagoPendienteScreen />} />

        {/* RUTA PROTEGIDA DE ALUMNO (Requiere login + suscripción activa) */}
        <Route 
          path="/home" 
          element={
            <UserRoute>
              <UserHomeScreen />
            </UserRoute>
          } 
        />

        {/* RUTAS BLINDADAS DE ADMINISTRACIÓN (Solo Mariana) */}
        <Route 
          path="/admin" 
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          } 
        />
        <Route 
          path="/admin/usuarios" 
          element={
            <AdminRoute>
              <UsuariosAdmin />
            </AdminRoute>
          } 
        />
        <Route 
          path="/admin/usuarios/:uid" 
          element={
            <AdminRoute>
              <UsuarioDetalle />
            </AdminRoute>
          } 
        />
        <Route 
          path="/admin/rutinas" 
          element={
            <AdminRoute>
              <ListadoCategorias />
            </AdminRoute>
          } 
        />
        <Route 
          path="/admin/rutinas/:categoria" 
          element={
            <AdminRoute>
              <VideosPorCategoriaAdmin />
            </AdminRoute>
          } 
        />
        <Route 
          path="/admin/reportes" 
          element={
            <AdminRoute>
              <ReportesAdmin />
            </AdminRoute>
          } 
        />
        <Route 
          path="/admin/faq" 
          element={
            <AdminRoute>
              <FaqAdminScreen />
            </AdminRoute>
          } 
        />

        {/* REDIRECCIÓN DE RUTAS NO ENCONTRADAS */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </Router>
  );
}

export default App;